import { render, staticRenderFns } from "./template-2.vue?vue&type=template&id=39d49864&scoped=true"
import script from "./template-2.vue?vue&type=script&lang=js"
export * from "./template-2.vue?vue&type=script&lang=js"
import style0 from "./template-2.vue?vue&type=style&index=0&id=39d49864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d49864",
  null
  
)

export default component.exports